import React from "react";

import dayjs from "dayjs";
import {	
	Skeleton,
	Button,
	Select,
	DatePicker,
	Input,
	Checkbox,
	Row,
	Col,
	List,
	theme	
} from "antd";

import { 
	SmileOutlined ,
	CloseCircleOutlined,
	CheckOutlined
} from "@ant-design/icons";
import { reduceText } from "../../utils/Formaters";

import PropTypes from "prop-types";
import { hover_item } from "../../hover";

const { RangePicker } = DatePicker;
const { Search } = Input;

const rangePresets = [
	{
		label: "Last 7 Days",
		value: [dayjs().add(-7, "d"), dayjs()],
	},
	{
		label: "Last 14 Days",
		value: [dayjs().add(-14, "d"), dayjs()],
	},
	{
		label: "Last 30 Days",
		value: [dayjs().add(-30, "d"), dayjs()],
	},
	{
		label: "Last 90 Days",
		value: [dayjs().add(-90, "d"), dayjs()],
	},
];

const ErrorsView = ({
	filterOptions, 
	selectedOptions, 
	loadDataAndOrUpdateParameters,
	onRangeChange,
	onChangeSearch,
	indeterminate,
	checkAll,
	onChangeAllSelect,
	massiveCheckedList,
	errorsReports,
	updateStatusError,
	loadingSubmit,
	pageSize,
	onChangeElementSelected,
	setHoveredItem,
	selected,
	hoveredItem ,
	setSelected,
	showEdit,
	empty_report_error,
	loading,
}) => {

	const {token:antToken} = theme.useToken();

	return (
		<>
			<Row gutter={[10,0]}>
				<Col span={3}>
					<Select
						style={{width:"100%"}}
						showSearch
						placeholder="Tipo de Proceso ejecutado"
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={filterOptions.process_errors}
						onChange={(value) => {
							loadDataAndOrUpdateParameters("name_process", value);
						}}
						value={selectedOptions.name_process}
					/>
				</Col>
				<Col span={3}>
					<Select
						style={{width:"100%"}}
						showSearch
						placeholder="Tipo de Error"
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={filterOptions.types_errors}
						onChange={(value) => {
							loadDataAndOrUpdateParameters("type", value);
						}}
						value={selectedOptions.type}
					/>
				</Col>
				<Col span={3}>
					<Select
						style={{width:"100%"}}
						showSearch
						placeholder="Estados de los reportes"
						optionFilterProp="children"
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={[
							{
								value:false,
								label:"Pendientes"
							},							
							{
								value:true,
								label:"Ya corregidos"
							}
						]}
						onChange={(value) => {
							loadDataAndOrUpdateParameters("error_verified", value);
						}}
						value={selectedOptions.error_verified}
					/>
				</Col>
				<Col span={5}>
					<RangePicker
						presets={rangePresets}
						style={{width:"100%"}}
						onChange={onRangeChange}
					/>
				</Col>
				<Col span={10}>
					<Search
						placeholder="Buscar"
						onChange={onChangeSearch}
						enterButton
					/>
				</Col>

			</Row>
			{selectedOptions.error_verified === false && 
				<Row>
					<Col span={8}>
						<Checkbox 
							indeterminate={indeterminate} 
							checked={checkAll} 
							onChange={onChangeAllSelect}
							style={{marginTop: "13px"}}
						>
							Seleccionar Todo
						</Checkbox>
					</Col>
					<Col span={8}>
						<p>{`${massiveCheckedList.length} de ${errorsReports.length} errores seleccionados`}</p>
					</Col>
					<Col span={8}>
						<Button 
							disabled={(massiveCheckedList.length < 2)} 
							type="primary"
							style={{marginTop: "5px"}}
							onClick={updateStatusError}
							loading={loadingSubmit}
							ghost
						>
							Corrección Masiva
						</Button>								
						
					</Col>
				</Row>
			}
			<List
				pagination={{
					position:"top",
					align:"center",
					pageSize: pageSize,
					showSizeChanger: false,
					disabled: false,
					showTotal:(total, range) => `${range[0]}-${range[1]} de ${total} Errores`
				}}
				dataSource={errorsReports}
				header={
					<Row
						style={{
							background: antToken.colorBgLayout,
							borderRadius:"10px"
						}}
					>
						<Col flex="auto">
							<List.Item key={0} >
								<List.Item.Meta 
									style={{maxWidth:"40px"}}
								/>
								<List.Item.Meta 
									title="Nombre de Proceso"
								/>
								<List.Item.Meta 
									title="Tipo" 
								/>
								<List.Item.Meta 
									title="Fecha" 
								/>
							</List.Item>
						</Col>
					</Row>
				}
				renderItem={(item, index) => (
					<Row>
						<Col flex="30px">
							<Checkbox
								disabled={(selectedOptions.error_verified !== false)}
								checked={((massiveCheckedList.find((checked) => checked === item.id)) === undefined) ? false : true}
								onChange={(e) => onChangeElementSelected(e, item.id)} 
								style={{marginTop: "20px", marginRight: "20px"}}
							/>
						</Col>
						<Col flex="auto">
							<List.Item
								key={index}
								onMouseEnter={() => setHoveredItem(index)}
								onMouseLeave={() => {
									if(selected === empty_report_error){
										setHoveredItem(null);
									}
								}}
								style={hover_item(hoveredItem === index, antToken, "invoices", 45)}
								onClick={() => {
									setSelected(item);
									showEdit();
									setHoveredItem(index);
								}}
								
							>
								<Skeleton avatar title={false} loading={loading} active>
									<List.Item.Meta
										title={reduceText(item.name_process)}
									/>										
									<List.Item.Meta
										description={reduceText(item.type)}
									/>										
									<List.Item.Meta
										description={item.date}
									/>										
									{(item.error_verified) ? (<CheckOutlined style={{ color: "green" }}/>) : (<CloseCircleOutlined style={{ color: "red" }}/>)}
								</Skeleton>
							</List.Item>
						</Col>
					</Row>
				)}
			/>
		</>
	);
};

const ErrorNotFounded = ({setSeeErrorsReports}) => {
	return (
		<>
			<SmileOutlined style={{ fontSize: "100px", paddingTop: "10%" }} />
			<h1>No se encontraron Errores</h1>
			<Button
				onClick={() => setSeeErrorsReports(true)}
			>
				Ver Historial
			</Button>
		</>
	);
};

ErrorsView.propTypes = {	
	filterOptions: PropTypes.object.isRequired, 
	selectedOptions: PropTypes.object.isRequired, 
	loadDataAndOrUpdateParameters: PropTypes.func.isRequired,
	onRangeChange: PropTypes.func.isRequired,
	onChangeSearch: PropTypes.func.isRequired,
	indeterminate: PropTypes.bool.isRequired,
	checkAll: PropTypes.bool.isRequired,
	onChangeAllSelect: PropTypes.func.isRequired,
	massiveCheckedList: PropTypes.array.isRequired,
	errorsReports: PropTypes.array.isRequired,
	updateStatusError: PropTypes.func.isRequired,
	loadingSubmit: PropTypes.bool.isRequired,
	pageSize: PropTypes.number.isRequired,
	onChangeElementSelected: PropTypes.func.isRequired,
	setHoveredItem: PropTypes.func.isRequired,
	selected: PropTypes.object.isRequired,
	hoveredItem: PropTypes.number.isRequired,
	setSelected: PropTypes.func.isRequired,
	showEdit: PropTypes.func.isRequired,
	empty_report_error: PropTypes.object.isRequired,
	loading: PropTypes.bool.isRequired,	
};

ErrorNotFounded.propTypes = {
	setSeeErrorsReports: PropTypes.func.isRequired,
};

export {ErrorsView, ErrorNotFounded };